// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccessRequestItem__container-afb133 {
  margin: 8px 24px;
  display: flex;
}

.AccessRequestItem__card-bf8bd3 {
  display: flex;
  flex: 1;
}

.AccessRequestItem__icon-b0ec76 {
  margin-inline-end: 16px;
  padding: 0;
}

.AccessRequestItem__icon-b0ec76:last-child {
  margin-inline-end: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SecretChatRequestAccessPopup/components/AccessRequestItem/AccessRequestItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;AACF;;AAEA;EACE,uBAAA;EACA,UAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".container {\n  margin: 8px 24px;\n  display: flex;\n}\n\n.card {\n  display: flex;\n  flex: 1;\n}\n\n.icon {\n  margin-inline-end: 16px;\n  padding: 0;\n}\n\n.icon:last-child {\n  margin-inline-end: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AccessRequestItem__container-afb133`,
	"card": `AccessRequestItem__card-bf8bd3`,
	"icon": `AccessRequestItem__icon-b0ec76`
};
module.exports = ___CSS_LOADER_EXPORT___;
